/**
  * 业务员 接口的出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const salesman = {
    // 列表
    list (params) {
        return axios.get(api + 'salesman/list', { params: params })
    },
    //添加
    create (params) {
        return axios.post(api + 'salesman/create', qs.stringify(params))
    },
    //获取编辑信息
    detail (params) {
        return axios.get(api + 'salesman/detail', { params: params })
    },
    //修改
    edit (params) {
        return axios.post(api + 'salesman/edit', qs.stringify(params))
    },
    //删除
    isremove (params) {
        return axios.get(api + 'salesman/isremove', { params: params })
    },
    remove (params) {
        return axios.post(api + 'salesman/remove', qs.stringify(params))
    },
    status (params) {
        return axios.post(api + 'salesman/status', qs.stringify(params))
    },
    // 扫码记录
    saomalog (params) {
        return axios.get(api + 'salesman/saomalog', { params: params })
    },
}


// 导出接口
export default salesman
